module.exports = __webpack_public_path__ + "img/admin-customer-detail.d3357b84.png";